import { Box, Typography } from "@mui/material";
import { BlackButtonComponent } from "../../components";
import useBasicDetailsScreen from "./hooks/basic-details";
import { useState } from "react";
// import OtpVerifyDialog from "../auth/otp-verify-dialog";
import MerchantDetailsForm from "../../components/shared/basic-details-form/basic-details-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { toast } from "react-toastify";
import { appendDetails } from "services/MerchantHostApi";
import { updateHostState } from "slice/hostSlice";
import { containsPropertyHost, getChangedFields } from "../../utils/index";
import { useNavigate } from "react-router";

const BasicDetailsScreen = () => {
  const { formik } = useBasicDetailsScreen();
  const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);
  const [isPasswordOpen, setIsPasswordOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState(formik.values);

  const userDetails = useSelector(
    (state: RootState) => state.appLayout.userDetails
  ) as any;

  const handleSubmit = async () => {
    if (!formik.isValid) {
      toast.error("Please fill in all required fields correctly.");
      return;
    }
    const changedFields = getChangedFields(initialValues, formik.values);
    setLoading(true);
    try {
      const data:any = {
        hostBasicDetails: {
          ...formik.values,
          updatedItems: changedFields,
        },
      };

      const val = containsPropertyHost(userDetails, "hostBasicDetails");

      if (val === "UPDATE") {
        data.kycStatus = "UPDATE";
      } else if (val === "TRUE") {
        data.kycStatus = "COMPLETED";
      }

      const response = await appendDetails(
        userDetails.userType,
        userDetails.userId,
        data
      );

      if (response?.message === "Item updated successfully") {
        toast.success("Host details updated successfully!");
        dispatch(updateHostState(response?.updatedItem));
        setInitialValues(formik.values);
        navigate("/kyc");
        window.location.reload();
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(
        "Failed to update details. Please check your network and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" rowGap={2}>
      <Box>
        <Typography variant="h5" mb={2}>
          Basic Details
        </Typography>
      </Box>

      <MerchantDetailsForm
        formik={formik}
        isPasswordOpen={isPasswordOpen}
        setIsPasswordOpen={setIsPasswordOpen}
        setIsOtpDialogOpen={setIsOtpDialogOpen}
        isMobileVerified={userDetails.isMobileVerified}
      />

      <Box textAlign="right" display="flex" justifyContent="end" columnGap={2}>
        <BlackButtonComponent
          onClick={handleSubmit}
          btnText={loading ? "Submitting..." : "Submit"}
          sx={{ padding: "6px 40px" }}
          disabled={loading}
        />
      </Box>
      {isOtpDialogOpen && (
        // <OtpVerifyDialog
        //   handleClose={() => setIsOtpDialogOpen(true)}
        //   handleVerification={handleOtpVerification}
        // />
        <div></div>
      )}
    </Box>
  );
};

export default BasicDetailsScreen;
